import React from 'react';
import { Helmet } from 'react-helmet';

import config from '../website-config';
import { useI18n } from './I18nContext';
import { LOCALES, localizePath, stripLocalePrefix } from './locales';

type LocaleHeadProps = {
  pathname: string;
};

export function LocaleHead({ pathname }: LocaleHeadProps) {
  const { locale } = useI18n();
  const canonical = stripLocalePrefix(pathname);

  return (
    <Helmet>
      <html lang={locale} />
      {LOCALES.map(code => (
        <link
          key={code}
          rel="alternate"
          hrefLang={code}
          href={`${config.siteUrl}${localizePath(canonical, code)}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${config.siteUrl}${localizePath(canonical, 'en')}`}
      />
    </Helmet>
  );
}
